var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.795898,
    y: 0.17749,
    width: 42,
    height: 42,
    rx: 12,
    fill: "#4C4E7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.545 18.8871V18.1825C28.545 14.3137 25.5233 11.1775 21.7959 11.1775C18.0685 11.1775 15.0468 14.3137 15.0468 18.1825V18.8871C15.0468 19.7326 14.8056 20.5593 14.3537 21.2629L13.2463 22.987C12.2347 24.5618 13.0069 26.7024 14.7663 27.2004C19.3686 28.5032 24.2232 28.5032 28.8255 27.2004C30.5849 26.7024 31.3571 24.5618 30.3455 22.987L29.2381 21.2629C28.7862 20.5593 28.545 19.7326 28.545 18.8871Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2959 28.1775C17.9509 29.9253 19.7184 31.1775 21.7959 31.1775C23.8734 31.1775 25.6409 29.9253 26.2959 28.1775",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.00a3137202fbb97d6121ff3cd04ad1fc.svg";
export { ForwardRef as ReactComponent };